// extracted by mini-css-extract-plugin
export default {"header":"style_header__IfH9V","titleWrap":"style_titleWrap__4ZOdf","title":"style_title__rhY0P","stats":"style_stats__3fupL","actions":"style_actions__GPsfo"};